import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-column">
            <h4>RIVERTON DAIRY</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/products">Our Products</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>PRODUCTS</h4>
            <ul>
              <li><Link to="/products">Marula Yogurt</Link></li>
              <li><Link to="/products">Banana Yogurt</Link></li>
              <li><Link to="/products">Strawberry Yogurt</Link></li>
              <li><Link to="/products">Orange Yogurt</Link></li>
              <li><Link to="/products">Pineapple Yogurt</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>CONTACT INFO</h4>
            <ul>
              <li><i className="fas fa-map-marker-alt"></i> ADL House, P.O. Box 31507, Lilongwe </li>
              <li><i className="fas fa-phone"></i> +265 111 775 433</li>
              <li><i className="fas fa-phone"></i> +265 998 955 221</li>
              <li><i className="fas fa-envelope"></i> info@rivertonmw.com</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Riverton Dairy Limited. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
